import { Tabs } from './lib/tabs.js';
import { Tab } from './lib/tab.js';
import { TabSection } from './lib/tab-section.js';
customElements.define('cipublic-tabs', Tabs);
customElements.define('cipublic-tab', Tab);
customElements.define('cipublic-tab-section', TabSection);
//# sourceMappingURL=cipublic-tabs.js.map